module.exports = __webpack_public_path__ + "img/bbc.78f68be.png";